export default "__VITE_ASSET__b1e1f368__"